import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import { Box } from '@mui/material';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { SourceConfig, SourcePlayback } from '../helpers/sourceHelper';

type SourceViewerProps = {
  sourceConfig: SourceConfig;
  onLoad: (sourcePlayback: SourcePlayback) => void;
};

let stream: MediaStream;

function SourceViewer(props: SourceViewerProps) {
  const [sourceUrl, setSourceUrl] = useState<string>();
  const [isLoading, setLoading] = useState(false);
  const [isCameraError, setCameraError] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  // useEffectAfterMount(() => {
  //   setSourceUrl(undefined);
  //   setLoading(true);
  //   setCameraError(false);

  //   // Enforces reloading the resource, otherwise
  //   // onLoad event is not always dispatched and the
  //   // progress indicator never disappears
  //   setTimeout(() => setSourceUrl(props.sourceConfig.url));
  // }, [props.sourceConfig]);

  useEffect(() => {
    setSourceUrl(undefined);
    setLoading(true);
    setCameraError(false);

    // Enforces reloading the resource, otherwise
    // onLoad event is not always dispatched and the
    // progress indicator never disappears
    setTimeout(() => setSourceUrl(props.sourceConfig.url));
  }, [props.sourceConfig]);

  useEffect(() => {
    async function getCameraStream() {
      try {
        const constraint = { video: true };
        stream = await navigator.mediaDevices.getUserMedia(constraint);
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          return;
        }
      } catch (error) {
        console.error('Error opening video camera.', error);
      }
      setLoading(false);
      setCameraError(true);
    }

    if (props.sourceConfig.type === 'camera') {
      getCameraStream();
    } else if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  }, [props.sourceConfig]);

  useEffect(() => {
    return () => {
      // stop camera on unmount
      if (stream) {
        stream.getVideoTracks()[0].stop();
      }
    };
  }, []);

  function handleImageLoad(event: SyntheticEvent) {
    const image = event.target as HTMLImageElement;
    props.onLoad({
      htmlElement: image,
      width: image.naturalWidth,
      height: image.naturalHeight,
    });
    setLoading(false);
  }

  function handleVideoLoad(event: SyntheticEvent) {
    const video = event.target as HTMLVideoElement;
    props.onLoad({
      htmlElement: video,
      width: video.videoWidth,
      height: video.videoHeight,
    });
    setLoading(false);
  }

  return (
    <Box
      sx={theme => ({
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        [theme.breakpoints.down('xs')]: {
          width: 0,
          overflow: 'hidden',
        },

        // [theme.breakpoints.up('sm')]: {
        //   flex: 1,
        //   borderRightWidth: 1,
        //   borderRightStyle: 'solid',
        //   borderRightColor: theme.palette.divider,
        // },
      })}
    >
      {/* {isLoading && <CircularProgress />} */}
      {props.sourceConfig.type === 'image' ? (
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          component={'img'}
          src={sourceUrl}
          hidden={isLoading}
          alt=""
          onLoad={handleImageLoad}
        />
      ) : isCameraError ? (
        <VideocamOffIcon fontSize="large" />
      ) : (
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          component={'video'}
          ref={videoRef}
          src={sourceUrl}
          hidden={isLoading}
          autoPlay
          playsInline
          controls={false}
          muted
          loop
          onLoadedData={handleVideoLoad}
        />
      )}
    </Box>
  );
}

export default SourceViewer;
